import { call, takeLatest, select, fork, put } from 'redux-saga/effects';
import {
  requestHistoricalValues,
  requestObservationsValues,
} from '../requesters/weatherRequester';
import {
  REQUEST_WEATHER_DATA,
  REQUEST_WEATHER_OBSERVATIONS,
} from '../constants/actionTypes';
import { logDmbErrorLocation } from '../utils/error';

import {
  receiveWeatherData,
  failureWeatherData,
  receiveObservationsData,
  failureWeatherObservationsData
} from '../actions/weatherActions';

export function* getWeatherData() {
  try {
    const state = yield select();
    const response = yield call(requestHistoricalValues, state.field.id);
    yield put(receiveWeatherData(response.results));
  } catch (error) {
    logDmbErrorLocation(error, 'weather saga');
    yield put(failureWeatherData());
  }
}

export function* getObservationsData(action) {
  try {
    const { fieldId, season, useMicrosoftGDD } = action;

    const response = yield call(
      requestObservationsValues,
      fieldId,
      season,
      useMicrosoftGDD
    );
    yield put(receiveObservationsData(response, season, useMicrosoftGDD));
  } catch (error) {
    logDmbErrorLocation(error, 'weather saga');
    yield put(failureWeatherObservationsData());
  }
}

export function* getWeatherDataWatcher() {
  yield [
    takeLatest(REQUEST_WEATHER_DATA, getWeatherData),
    takeLatest(REQUEST_WEATHER_OBSERVATIONS, getObservationsData),
  ];
}

/**
 * Uses fork to start multiple watchers in parallel
 * @return {void}
 */
export default function* rootSaga() {
  yield fork(getWeatherDataWatcher);
}
